import { scaleLinear } from 'd3-scale';
import { interpolateHcl } from 'd3-interpolate';
import { easePolyIn } from 'd3-ease';
import { timer } from 'd3-timer';



export function animatePoints(points, action, duration=2000, axes=[]) {

  // set the current x, y to x1, y1 so you can iterate between x0, y0 and x1, y1
  let colorCombos = new Set();
  points.forEach(point => {
    point.x1 = point.x;
    point.y1 = point.y;
    point.color1 = point.color;

    const colorCombo = point.color0 + '|' + point.color1;
    point.colorCombo = colorCombo;
    colorCombos.add(colorCombo)
  });

  // replot the chart over and over again as vals shift from x0,y0 to x1, y1
  //    when you're done x,y will equal x1, y1
  const ease = easePolyIn;
  const myTimer = timer(elapsed => {

    // compute how far through the animation we are; 0 (start) to 1 (end)
    const t = Math.min(1, ease(elapsed / duration));

    // fadeIn/Out
    let opacity = 1;
    if (['fadeIn', 'fadeOut'].includes(action)) {
      opacity = action == 'fadeIn' ? t : (1-t);
    }

    // get current color for each colorCombo
    let colorComboDict = {};
    colorCombos.forEach(colorCombo => {
      const colorArr = colorCombo.split('|');
      const color0 = colorArr[0];
      const color1 = colorArr[1];
      colorComboDict[colorCombo] = interpolateColor(t, color0, color1);
    });

    // only show some points depending on action
    let numToShow = points.length;
    if (action === 'reveal') {
      numToShow = Math.ceil(numToShow * t);
    } else if (action === 'hide') {
      numToShow = Math.floor(numToShow * (1-t));
    }
    const subPoints = points.slice(0, numToShow);


    // update point positions (interpolate between source and target)
    subPoints.forEach(point => {
      point.x = point.x0 * (1 - t) + point.x1 * t;
      point.y = point.y0 * (1 - t) + point.y1 * t;
      point.color = colorComboDict[point.colorCombo];
      // point.color = t === 1 ? point.color1 : point.color0;
    });


    // update what is drawn on screen
    plot(subPoints, opacity, axes);

    // if this animation is over
    if (t === 1) {
      // stop this timer since we are done animating.
      myTimer.stop()
    }
  });
}


function interpolateColor(pct, color0, color1) {
  let color = scaleLinear()
    .domain([0, 1])
    .range([color0, color1])
    .interpolate(interpolateHcl);
  return color(pct)
} 


export function plot(points, opacity, axes=[], pointWidth=4) {
  // draw all the points on the canvas
  //  'points' = arr of points
  //  'pointWidth' = width in pixels
  //  plot rects using point.x and point.y of each point
  //  fill using point.color
  //  size of point = pointWidth

  // get the canvas
  const canvas = document.getElementById('chartCanvas');
  const ctx = canvas.getContext('2d');
  
  // save the state
  ctx.save();

  // get height and width
  const dimensions = canvas.getBoundingClientRect();

  // erase what is on the canvas currently
  ctx.clearRect(0, 0, dimensions.width, dimensions.height);

  // opacity
  ctx.globalAlpha = opacity;
  
  // draw each point as a rectangle
  for (let i = 0; i < points.length; ++i) {
    const point = points[i];
    ctx.fillStyle = point.color;
    ctx.fillRect(point.x, point.y, pointWidth, pointWidth);
  }


  // add axes if necessary
  if (axes.length > 0) {
    ctx.fillStyle = 'rgb(30, 30, 30)';
    axes.forEach(a => {
      ctx.fillRect(a.x+10, a.y+1, 5, 1);
      ctx.textAlign = 'end';
      ctx.textBaseline = "middle";
      ctx.font = "12px 'Noticia Text'";
      ctx.strokeText(a.label, a.x+5, a.y+2);
    });
  }

  // save
  ctx.restore();
}
